export class CodiceFiscale {
      nome:string;
      cognome:string;
      dataDiNascita:string;
      comuneNascita:string;
      sesso:string; 
}


// WEBPACK FOOTER //
// ./src/angular_library/models/codiceFiscale.ts